export default __webpack_public_path__ + "static/brush-stroke-purple-06d6954042dd278ce2e7e816d6f99f40.svg";